import { useQuery } from "@tanstack/react-query"
import GameScreenLayout from "@/components/GameScreenLayout"

type Props = {
  title: string
  queryKey: string
  queryFn: () => Promise<unknown>
  backTo?: string
}

export default function FeatureDataPage({ title, queryKey, queryFn, backTo }: Props) {
  const q = useQuery({ queryKey: [queryKey], queryFn })

  return (
    <GameScreenLayout title={title} backTo={backTo}>
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : q.isError ? (
        <p className="text-sm text-red-400">Ошибка загрузки</p>
      ) : (
        <pre className="max-h-[70vh] overflow-auto rounded-xl border border-white/10 bg-black/30 p-3 text-xs text-guardians-muted">
          {JSON.stringify(q.data, null, 2)}
        </pre>
      )}
    </GameScreenLayout>
  )
}
